import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class IncExcKeyCriteria extends BasicCriteria {
visionCode: string;
visionCodeList: string[];
}

